import React from 'react'
import { Link } from "react-router-dom";


import PhillyFridges from './phillyfridges'
import phlcommunityfridge from '../assets/philcomfridge/phlcommunityfridge-7.jpg'

import './components.css'
import '../App.css'

const Philadelphia = () =>{

    return(
       
        <div className="profile-container">
            <header>
                <nav>
                    <span className="nav-span">
                        <Link to ="/">
                        <PhillyFridges/>
                        </Link>
                    </span>
                </nav>
            </header>

            <div className="profile">
                <img className="phypho seven" src={phlcommunityfridge} />

                <div className="main-heading-container">
                    <h1 className="main-heading">Philadelphia Community Fridge</h1>
                    <h5 className="address-heading">1229 S 6th Street (Radiance Medical Group) & 1901 S 9th Street (BOK)</h5>
                </div>

                <section className="mission">
                    <h4 className="section-heading">Mission</h4>
                             <p>We're a community-centered, volunteer-based organization
                            dedicated to giving all Philadelphians access to fresh and healthy
                            food, combatting food insecurity and inequality in our city
                            through mutual aid. Studies show that nearly 1 in 5 Philadelphia families struggle
                            with hunger, and food pantries' demand for fresh produce has
                            increased 3x since 2019. We partner with local grocers and restaurants to stock this
                            fridge with perfectly good produce, pantry staples, and prepared
                            foods that would otherwise be thrown out.</p>
                        <div>
                            <h6>BEING ABLE TO FEED YOURSELF AND
                            YOUR FAMILY ISN'T A PRIVILEGE —
                            IT'S A BASIC HUMAN RIGHT.</h6>                        
                        </div>           
                </section>


                <section className="contact">
                    <h4 className="section-heading">Contact Information</h4>
                    <div>
                    <i class="far fa-paper-plane"/> philadelphiacommunityfridge@gmail.com <br/>
                    <i class="fab fa-instagram"/> @phlcommunityfridge  <br/>
                    <i class="fab fa-twitter"/> @phillyfridge <br/>
                    <i class="fab fa-facebook"/> https://www.facebook.com/phlcommunityfridge</div>
                </section>



                <section className="donations">
                    <h4 className="section-heading">Donation Drop-Off Information</h4>
                    <span> The fridge is accessible 24/7 for drop-offs.<br/> Here is what we do and do not accept:</span>
                    <div className="yesno">
                        <div>
                            <h6>Yes, please!</h6>
                            <ul>
                            <li>Fresh Produce</li>
                            <li>Fruits, Vegetables, and Herbs</li>
                            <li>Picked goods</li>
                            <li>Prepackaged salad kits</li>
                            <li>Breads & Pastries</li>
                            <li>Eggs</li>
                            <li>Unopened Dairy products</li>
                            <li>Pantry items</li>
                            <li>Condiments, dressings, sauces</li>
                            <li>Rices, pastas, grains</li>
                            </ul>
                        </div>
                                                
                        <div>
                            <h6>No, thank you!</h6>
                            <ul>
                            <li>ANY meat, fish, seafood</li>
                            <li>Alcohol</li>
                            <li>Leftovers</li>
                            <li>Past expiration date products</li>
                            <li>Unlabelled products</li>
                            <li>Homemade meals from households due to sanitary reasons</li>
                            <li>Anything you wouldn't feed to your own family!</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="volunteer">
                    <div>
                        <h4 className="section-heading">Volunteer Information</h4> <p>If you would like to volunteer, email philadelphiacommunityfridge@gmail.com with your name, pronouns, email address, and phone number. Our two main volunteer needs are people who can clean/sanitize the fridge on a daily basis, and people who can purchase or pickup food and transport it to the fridge. However, we have lots of other volunteer positions and are always looking for more volunteers to support the fridge!</p>
                    </div>
                </section>


                <section className="media">
                    <h4 className="section-heading">Media Coverage</h4>

                    <div>
                       <iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/aeErFXAjbps?controls=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                       
                    <div>
                        <a href="https://whyy.org/articles/people-are-putting-stocked-fridges-on-philly-sidewalks/" target="_blank">WHYY.ORG Article</a> 
                    </div>
                </section>
             
                

            </div>
        </div>
    )
}

export default Philadelphia